const FEATURES_STORAGE_KEY = "__app_features__";

class FeaturesService {
  private features: Set<string> = new Set();

  setFeatures(features: string[]): void {
    this.features = new Set(features);

    if (typeof window !== "undefined") {
      try {
        const encoded = btoa(JSON.stringify(features));
        localStorage.setItem(FEATURES_STORAGE_KEY, encoded);
      } catch (error) {
        console.error("Error storing features:", error);
      }
    }
  }

  getFeatures(): string[] {
    if (this.features.size === 0 && typeof window !== "undefined") {
      try {
        const encoded = localStorage.getItem(FEATURES_STORAGE_KEY);
        if (encoded) {
          const decoded = JSON.parse(atob(encoded));
          this.features = new Set(decoded);
        }
      } catch (error) {
        console.error("Error retrieving features:", error);
      }
    }
    return Array.from(this.features);
  }

  hasFeature(feature: string): boolean {
    if (this.features.size === 0) {
      this.getFeatures();
    }
    return this.features.has(feature);
  }

  clearFeatures(): void {
    this.features.clear();
    if (typeof window !== "undefined") {
      localStorage.removeItem(FEATURES_STORAGE_KEY);
    }
  }
}

export const featuresService = new FeaturesService();

/**
 * Compara dois conjuntos de features (ordem-insensível). Usado pelos caminhos
 * de refresh (interceptor axios e SSE) para decidir se a página precisa
 * recarregar e reaplicar o gating de permissões — useFeature/FeatureGuard
 * leem o conjunto uma única vez, então mudança silenciosa não re-renderiza.
 */
export const haveFeaturesChanged = (
  before: string[],
  after: string[]
): boolean =>
  before.length !== after.length ||
  before.some(feature => !after.includes(feature)) ||
  after.some(feature => !before.includes(feature));
